export default __webpack_public_path__ + "static/media/BaseballBat_6.65bbccaf.png";